<template>
  <VBtn elevation="4" :color="isDark ? 'on-surface' : 'primary'" v-bind="$attrs">
    <slot />
    <template v-slot:loader>
      <ProgressBar size="24" width="2" color="white" />
    </template>
  </VBtn>
</template>
<script setup>
import { useThemeConfig } from '@/composables/useThemeConfig';
const { theme } = useThemeConfig();
const isDark = computed(() => theme.value === 'dark');
</script>
